import { request } from '@max/meituan-uni-network';
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
// 会报错，先不主动上报ajax相关错误
// import { reportJSInfo } from '@max/meituan-uni-report';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { handleParams } from './common-api/utils';
import { getAppVersionName } from './utils/common';
const systemType = getSystemType();
export var ExperimentPageFlag;
(function (ExperimentPageFlag) {
    ExperimentPageFlag[ExperimentPageFlag["OPEN"] = 1] = "OPEN";
})(ExperimentPageFlag || (ExperimentPageFlag = {}));
export const AJAX_ERROR_NAME = '网络错误';
const fetchData = (data, params = {}, options) => {
    // 完全和tex1.0 的poi动态列表保持一致
    const defaultData = {
        client: systemType === SystemType.android ? 'android' : 'iphone',
        sourceType: 'flagShip_promotion',
        childAges: '',
        roomCount: '1',
        numberOfAdults: '1',
        memberGoodsPoiFirst: true,
        numberOfChildren: '0',
        hideNoFlagshipGoodsPoi: false,
        filterFlagshipGoods: false
    };
    const realData = {
        ...defaultData,
        ...data
    };
    let finalData = realData;
    // console.log("加反爬参数之前",finalData)
    // const isPtest = true; // TODO: important
    // if (isPtest) {
    //   finalData.isPtest = 'true';
    //   params.isPtest = 'true';
    // }
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalData = antiReq.addCommonParams(finalData);
        }
        catch (e) {
            console.warn('添加反爬参数失败', e);
            // reportJSInfo({ level: 'info', content: '请求加上反爬参数错误', secCategory: 'ajaxError' });
        }
    }
    // console.log("请求前")
    const appVersion = getAppVersionName();
    return new Promise((resolve, reject) => {
        const hostUrl = 'https://ihotel.meituan.com';
        // const hostUrl = 'https://api.hotel.test.meituan.com';
        // const hostUrl = 'https://chenzhuo24-glvdc-sl-api.hotel.test.sankuai.com';
        request({
            // 站外没有version，这里先直接写死一个
            url: `${hostUrl}/landing/page/query/poi/dynamic/list/search/data?version_name=${appVersion}` + handleParams(params),
            method: 'POST',
            data: {
                ...finalData
            },
            header: {
                'Content-Type': 'application/json',
                token: params?.token,
                userid: params?.userId
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel',
                params
            },
            success(res) {
                options?.onApiSuccess?.();
                if (res?.data?.status === 0) {
                    const templateRes = res?.data?.data;
                    resolve(templateRes);
                }
                else {
                    const error = new Error(AJAX_ERROR_NAME);
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-code非200';
                    // const tags = {
                    //   response: JSON.stringify(res),
                    //   params: JSON.stringify(finalData),
                    // };
                    // reportJSInfo({
                    //   secCategory: 'ajaxError',
                    //   level: 'info',
                    //   error,
                    //   tags,
                    // });
                    reject(error);
                }
            },
            fail(error) {
                error.name = AJAX_ERROR_NAME;
                error.message = '请求接口异常-网络异常';
                // const tags = {
                //   test: JSON.stringify(error),
                //   params: JSON.stringify(finalData),
                // };
                // reportJSInfo({
                //   secCategory: 'ajaxError',
                //   level: 'info',
                //   error,
                //   tags,
                // });
                options?.onApiFail?.();
                reject(error);
            }
        });
    });
};
export default fetchData;
